import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import { or } from 'ember-truth-helpers';
import BvIcon from 'volta/components/bv-icon';

import type { TOC } from '@ember/component/template-only';

export interface BvTextFieldSpinnerSignature {
  Args: {
    onChange?: (steps: number) => void;
    onClick?: () => void;
    onDecrease?: () => void;
    onIncrease?: () => void;
  };
}

const BvTextFieldSpinnerComponent: TOC<BvTextFieldSpinnerSignature> = <template>
  {{! template-lint-disable no-invalid-interactive }}
  {{! template-lint-disable require-presentational-children }}
  <div
    data-test-text-field-spinner
    class='bv-text-field__spinner'
    aria-hidden='true'
    {{on 'click' (optional @onClick)}}
  >
    <div
      data-test-text-field-spinner-incr-button
      role='button'
      class='bv-text-field__segment'
      tabindex='-1'
      {{on 'click' (optional (or @onIncrease (fn (optional @onChange) 1)))}}
    >
      <div class='bv-text-field__spinner-icon'>
        <BvIcon @glyph='chevron-up' @size='xs' class='u-d-inline-flex' />
      </div>
    </div>
    <div
      data-test-text-field-spinner-decr-button
      role='button'
      class='bv-text-field__segment'
      tabindex='-1'
      {{on 'click' (optional (or @onDecrease (fn (optional @onChange) -1)))}}
    >
      <div class='bv-text-field__spinner-icon'>
        <BvIcon @glyph='chevron-down' @size='xs' class='u-d-inline-flex' />
      </div>
    </div>
  </div>
</template>;

export default BvTextFieldSpinnerComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvTextField::Spinner': typeof BvTextFieldSpinnerComponent;
    'bv-text-field/spinner': typeof BvTextFieldSpinnerComponent;
  }
}
